import { combineReducers } from "@reduxjs/toolkit";

import filters from "./filters";
import matches from "./matches";
import betslip from "./betslip";
import languages from "./languages";
import results from "./results";
// import moreMarkets from "./more-markets";
import extraMarkets from "./extraMarkets";
import topMatches from "./topMatches";
import favourites from "./favourites";
import mybets from "./mybets";
import stream from "./stream";
import topSponsoredEvent from "./topSponsoredEvent";
import betslipSponsored from "./betslipSponsord";
import closeChannels from "./common/index";
import extramarketFilter from "./extramarketFilter";
import sportsIframe from "./sportsIframe";
// import myBets from "./mybets";
// import favourite from "./favourite";
// import matchResult from "./results";
// import language from "./language";
// import featuredMatches from "./featuredMatches";
function lastAction(state = null, action) {
  return action;
}
const sportReducerNode = combineReducers({
  closeChannels,
  filters,
  matches,
  betslip,
  languages,
  results,
  mybets,
  // moreMarkets,
  extraMarkets,
  topMatches,
  favourites,
  stream,
  topSponsoredEvent,
  betslipSponsored,
  extramarketFilter,
  // myBets,
  // favourite,
  // matchResult,
  // language,
  lastAction,
  sportsIframe
});

export default sportReducerNode;
